import { isRejectedWithValue } from "@reduxjs/toolkit";
import { aggregatorApiUrl } from "../constants";
import httpClient from "./http_client";

class AggregatorSectionAPIService {
  constructor(aggregatorApiUrl) {
    this.aggregatorApiUrl = aggregatorApiUrl;
  }

  async fetchChatResponse(params) {
    try {
      const response = await httpClient.post(`${this.aggregatorApiUrl}/chat`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async fetchTableColumnData(params) {
    try {
      const response = await httpClient.post(`${this.aggregatorApiUrl}/table_info`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async fetchAggregatorData(params) {
    try {
      const response = await httpClient.post(`${this.aggregatorApiUrl}/aggregator`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }
  async fetchUserCreatedTables(params) {
    try {
      const response = await httpClient.post(`${this.aggregatorApiUrl}/list_user_created_tables`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async syncKnowledgeBaseItems(params) {
    try {
      const response = await httpClient.post(`${this.aggregatorApiUrl}/sync_with_KB`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async exportWorkbenchFileApi(params) {

    const { file, s3Key, outputFileName, isMeta, columnFileMap, isExistingTable } = params || {};
    if (!file && !params.s3Key) {
      throw isRejectedWithValue({ message: 'file must be a File or Blob', code: 'ERR_INVALID_ARG' });
    }

    const formData = new FormData();

    if (isMeta) {
      formData.append('file', null);
      formData.append('metafile', file, file ? file.name : 'uploadMeta.csv');
      formData.append('outputFileName', outputFileName);
      formData.append('columnFileMap', columnFileMap);
      formData.append('s3Key', s3Key)
    }
    else {
      if (!s3Key)
        formData.append('file', file, file ? file.name : 'upload.csv');
      else
        formData.append('file', null);
      formData.append('metafile', null);
      formData.append('outputFileName', outputFileName);
      formData.append('columnFileMap', '');
      formData.append('isExistingTable', isExistingTable);
      formData.append('s3Key', s3Key)
    }
    try {
      const response = await httpClient.post(
        `${this.aggregatorApiUrl}/upload_workbench_input_data`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response?.data;
    } catch (err) {
      const payload = err?.response?.data ?? { message: err?.message ?? 'Unknown error' };
      throw payload;
    }
  }

  async exportSchemaToWorkbenchFileApi(params) {
    try {
      const response = await httpClient.post(`${this.aggregatorApiUrl}/push_workbench_data`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

}

const aggregatorSectionAPIService = new AggregatorSectionAPIService(
  aggregatorApiUrl
);
export default aggregatorSectionAPIService;
